export default __webpack_public_path__ + "static/card3_img-f75a719cab5d53afc9452036342557ca.webp";